import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Custom Notebooks - INGAZ Print";

function Notebooks() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          <section className="product-details-section">
            <div className="product-container">
              <ProductGallery alt="Custom Notebooks" images={[asset('assets/notebooks_hero.png'), asset('assets/notebooks_open.png'), asset('assets/notebooks_stack.png'), asset('assets/notebooks_detail.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Custom Notebooks" data-ar="دفاتر مخصصة">Custom Notebooks</h1>
                <p className="product-description" data-en="Branded notebooks and notepads for corporate gifts, events, and promotional use." data-ar="دفاتر ملاحظات مخصصة لهدايا الشركات والفعاليات والاستخدام الترويجي.">Branded notebooks and notepads
                  for corporate gifts, events, and promotional use.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Year-Round" data-ar="طوال العام">Year-Round</div>
                      <div className="feature-detail" data-en="12 months" data-ar="12 شهرًا">12 months</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Customizable" data-ar="قابل للتخصيص">Customizable</div>
                      <div className="feature-detail" data-en="Your images" data-ar="صورك">Your images</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="Perfect for promotional giveaways and client gifts" data-ar="مثالي للهدايا الترويجية وهدايا العملاء">
                      Perfect for promotional giveaways and client gifts</li>
                    <li data-en="Custom covers with your branding" data-ar="أغلفة مخصصة بعلامتك التجارية">
                      Custom covers with your branding</li>
                    <li data-en="Multiple sizes and binding options" data-ar="أحجام وخيارات تجليد متعددة">
                      Multiple sizes and binding options</li>
                    <li data-en="High-quality paper for everyday use" data-ar="ورق عالي الجودة للاستخدام اليومي">
                      High-quality paper for everyday use</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Corporate Gifts" data-ar="هدايا الشركات">Corporate Gifts</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/calendar.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Events" data-ar="الفعاليات">Events</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/bag.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Office Supplies" data-ar="مستلزمات المكتب">Office Supplies</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Brand Marketing" data-ar="تسويق العلامة">Brand Marketing</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.
                </p>
              </div>
            </div>
          </section>
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Notebooks" data-ar="قم بتكوين دفاتر الملاحظات الخاصة بك">Configure Your Notebooks</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={100} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A4" data-dims="210x297 mm">A4<br /><span>210x297</span></div>
                    <div className="size-option" data-size="A5" data-dims="148x210 mm">A5<br /><span>148x210</span></div>
                    <div className="size-option" data-size="A6" data-dims="105x148 mm">A6<br /><span>105x148</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Other" data-ar="آخر">Other</span><br /><span data-en="Custom" data-ar="مخصص">Custom</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Orientation */}
                <div className="config-group">
                  <label data-en="Orientation" data-ar="الاتجاه">Orientation</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="orientation" defaultValue="portrait" defaultChecked />
                      <span data-en="Portrait" data-ar="طولي">Portrait</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="orientation" defaultValue="landscape" />
                      <span data-en="Landscape" data-ar="عرضي">Landscape</span>
                    </label>
                  </div>
                </div>
                {/* Number of inside pages */}
                <div className="config-group">
                  <label htmlFor="insidePages" data-en="Number of Inside Pages" data-ar="عدد الصفحات الداخلية">Number of Inside Pages</label>
                  <input type="number" id="insidePages" placeholder="Enter number of pages" min={1} defaultValue={100} data-placeholder-en="Enter number of pages" data-placeholder-ar="أدخل عدد الصفحات" />
                </div>
                {/* Binding type */}
                <div className="config-group">
                  <label htmlFor="bindingType" data-en="Binding Type" data-ar="نوع التجليد">Binding Type</label>
                  <div className="paper-select-wrapper">
                    <select id="bindingType">
                      <option value="stapled" data-en="Stapled" data-ar="دبوس">Stapled</option>
                      <option value="glue" data-en="Glue binding" data-ar="تجليد غراء">Glue binding</option>
                      <option value="white-double-wire" data-en="White double wire" data-ar="سلك مزدوج أبيض">White double wire</option>
                      <option value="black-double-wire" data-en="Black double wire" data-ar="سلك مزدوج أسود">Black double wire</option>
                      <option value="silver-metal-single" data-en="Silver metal single wire" data-ar="سلك مفرد معدني فضي">Silver metal single wire</option>
                      <option value="white-metal-single" data-en="White metal single wire" data-ar="سلك مفرد معدني أبيض">White metal single wire</option>
                      <option value="spiral" data-en="Spiral (plastic coil)" data-ar="حلزوني (بلاستيك)">Spiral (plastic coil)</option>
                    </select>
                  </div>
                </div>

                {/* --- COVER SECTION --- */}
                <h3 className="section-subtitle" data-en="Cover Specifications" data-ar="مواصفات الغلاف" style={{marginTop: '25px', marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px'}}>Cover Specifications</h3>
                
                {/* Cover Paper */}
                <div className="config-group">
                  <label htmlFor="coverPaperType" data-en="Cover Paper Type & Weight" data-ar="نوع ووزن ورق الغلاف">Cover Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="coverPaperType">
                      <option value="no-cover" data-en="No Cover [Notepad]" data-ar="بدون غلاف [دفتر ملاحظات]">No Cover [Notepad]</option>
                      <option value="couche-350" data-en="Couche 350 gsm" data-ar="كوشيه 350 جم">Couche 350 gsm</option>
                      <option value="couche-300" data-en="Couche 300 gsm" data-ar="كوشيه 300 جم">Couche 300 gsm</option>
                      <option value="couche-250" data-en="Couche 250 gsm" data-ar="كوشيه 250 جم">Couche 250 gsm</option>
                      <option value="greyboard" data-en="Greyboard / Rigid cardboard (hardcover)" data-ar="ورق مقوى صلب (غلاف مقوى)">Greyboard / Rigid cardboard (hardcover)</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>

                {/* Cover Printing */}
                <div className="config-group">
                  <label data-en="Cover Printed Colors" data-ar="ألوان طباعة الغلاف">Cover Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot red" />
                        <span className="dot green" />
                        <span className="dot blue" />
                      </div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots">
                        <span className="dot black" />
                        <span className="dot white" />
                      </div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>

                {/* Cover Printed Sides */}
                <div className="config-group">
                  <label data-en="Cover Printed Sides" data-ar="جوانب طباعة الغلاف">Cover Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="One side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>One side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double sides" data-ar="جانبان">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Double sides</span>
                    </div>
                  </div>
                </div>

                {/* Cover Lamination */}
                <div className="config-group">
                  <label data-en="Cover Lamination" data-ar="تغليف الغلاف">Cover Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="coverLamination" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="coverLamination" defaultValue="matt-one" />
                      <span data-en="Matt Cellophane [One side]" data-ar="سيلوفان مطفي [جانب واحد]">Matt Cellophane [One side]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="coverLamination" defaultValue="matt-both" />
                      <span data-en="Matt Cellophane [Both sides]" data-ar="سيلوفان مطفي [جانبين]">Matt Cellophane [Both sides]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="coverLamination" defaultValue="gloss-one" />
                      <span data-en="Gloss Cellophane [One side]" data-ar="سيلوفان لامع [جانب واحد]">Gloss Cellophane [One side]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="coverLamination" defaultValue="gloss-both" />
                      <span data-en="Gloss Cellophane [Both sides]" data-ar="سيلوفان لامع [جانبين]">Gloss Cellophane [Both sides]</span>
                    </label>
                  </div>
                </div>

                {/* --- INSIDES SECTION --- */}
                <h3 className="section-subtitle" data-en="Insides Specifications" data-ar="مواصفات الصفحات الداخلية" style={{marginTop: '25px', marginBottom: '15px', borderBottom: '1px solid #eee', paddingBottom: '10px'}}>Insides Specifications</h3>

                {/* Inside Pages Paper */}
                <div className="config-group">
                  <label htmlFor="insidePaperType" data-en="Inside Pages Paper" data-ar="ورق الصفحات الداخلية">Inside Pages Paper</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="insidePaperType">
                      <option value="white-100" data-en="White 100 gsm" data-ar="أبيض 100 جم">White 100 gsm</option>
                      <option value="white-80" data-en="White 80 gsm" data-ar="أبيض 80 جم">White 80 gsm</option>
                      <option value="white-70" data-en="White 70 gsm" data-ar="أبيض 70 جم">White 70 gsm</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>

                {/* Inside Page Layout */}
                <div className="config-group">
                  <label data-en="Inside Page Layout" data-ar="تخطيط الصفحة الداخلية">Inside Page Layout</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="insideLayout" defaultValue="plain" defaultChecked />
                      <span data-en="Plain (blank)" data-ar="سادة (فارغ)">Plain (blank)</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="insideLayout" defaultValue="lined" />
                      <span data-en="Lined / Ruled" data-ar="مسطر">Lined / Ruled</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="insideLayout" defaultValue="grid" />
                      <span data-en="Grid / Squared" data-ar="مربعات">Grid / Squared</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="insideLayout" defaultValue="custom" />
                      <span data-en="Custom printed layout" data-ar="تخطيط مطبوع مخصص">Custom printed layout</span>
                    </label>
                  </div>
                </div>

                {/* Insides Printed Sides */}
                <div className="config-group">
                  <label data-en="Insides Printed Sides" data-ar="جوانب طباعة الداخل">Insides Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="One side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>One side</span>
                    </div>
                    <div className="side-option" data-sides="double" data-en="Double sides" data-ar="جانبان">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Double sides</span>
                    </div>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                <NotesField />
                {/* Upload Design Files */}
                <div className="config-group">
                  <label data-en="Upload Design Files" data-ar="رفع ملفات التصميم">Upload Design Files</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here
                        or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS,
                        PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">A4</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Cover:" data-ar="الغلاف:">Cover:</span>
                    <span className="summary-value" id="summaryCoverPaper">Couche 350 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Inside Paper:" data-ar="ورق الداخل:">Inside Paper:</span>
                    <span className="summary-value" id="summaryInsidePaper">White 100 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Binding:" data-ar="التجليد:">Binding:</span>
                    <span className="summary-value" id="summaryBinding">Stapled</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-2 business days" data-ar="1-2 أيام عمل">1-2 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design
                    review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">
                    Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Related Products Section */}
          <section className="related-products-section">
            <div className="related-products-container">
              <h2 data-en="Related Products" data-ar="منتجات ذات صلة">Related Products</h2>
              <p className="related-subtitle" data-en="Explore our full range of printing services" data-ar="استكشف مجموعة كاملة من خدمات الطباعة">Explore our full range of printing services</p>
              <div className="related-products-grid">
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image1.webp')} alt="Business Cards" />
                  </div>
                  <h3 data-en="Business Cards" data-ar="بطاقات العمل">Business Cards</h3>
                  <p data-en="Professional business cards" data-ar="بطاقات عمل احترافية">Professional business cards</p>
                  <a href="/business-cards" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image5.webp')} alt="Brochures" />
                  </div>
                  <h3 data-en="Brochures" data-ar="الكتيبات">Brochures</h3>
                  <p data-en="Multi-page marketing material" data-ar="مواد تسويقية متعددة الصفحات">Multi-page marketing
                    material</p>
                  <a href="/brochures" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image3.webp')} alt="Leaflets" />
                  </div>
                  <h3 data-en="Leaflets" data-ar="المنشورات المطوية">Leaflets</h3>
                  <p data-en="Folded marketing materials" data-ar="مواد تسويقية مطوية">Folded marketing materials</p>
                  <a href="/leaflets" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image7.webp')} alt="Catalogs" />
                  </div>
                  <h3 data-en="Catalogs" data-ar="الكتالوجات">Catalogs</h3>
                  <p data-en="Product catalogs & lookbooks" data-ar="كتالوجات المنتجات والكتيبات">Product catalogs &amp; lookbooks
                  </p>
                  <a href="/catalogues" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
                <div className="related-product-card">
                  <div className="related-product-image">
                    <img src={asset('assets/image8.webp')} alt="Menus" />
                  </div>
                  <h3 data-en="Menus" data-ar="القوائم">Menus</h3>
                  <p data-en="Restaurant quality printing" data-ar="طباعة بجودة المطاعم">Restaurant quality printing</p>
                  <a href="/menus" className="btn2"><span data-en="Request quote" data-ar="طلب عرض أسعار">Request quote</span> <img src={asset('assets/arrow.svg')} alt="" className="btn-arrow" /></a>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default Notebooks;
